(function($) {
    var images = $('p > img, p > .fr-img-caption').unwrap();
})(jQuery);
